<era-lights-ui [lights]="lights()"></era-lights-ui>